import { memo, useState } from "react";

import Button from "@mui/material/Button";

import { Finding } from "stores/FindingStore";

import FindingEditModal from "./EditSeverityModal";

// -----------------------------------------------------------------------------

const OrganizationFindingDetailsEditSeverity = memo(
  function OrganizationFindingDetailsEditSeverity({
    finding,
  }: OrganizationFindingDetailsEditSeverityProps): JSX.Element {
    const [severityModalOpen, setSeverityModalOpen] = useState(false);

    //
    return (
      <>
        <Button
          variant="outlined"
          size="small"
          onClick={() => setSeverityModalOpen(true)}
        >
          Edit Severity
        </Button>

        {severityModalOpen && (
          <FindingEditModal
            onClose={() => setSeverityModalOpen(false)}
            finding={finding}
          />
        )}
      </>
    );
  }
);

export default OrganizationFindingDetailsEditSeverity;

// -----------------------------------------------------------------------------

interface OrganizationFindingDetailsEditSeverityProps {
  finding: Finding;
}
